const DEV_PDAPI_BASE = "https://dev-pdapi.astrophant.online/api";
const PROD_PDAPI_BASE = "https://pdapi.astrophant.online/api";

const normalizeBase = (value) => value.replace(/\/+$/, "");

const getPdApiBase = () => {
  const envBase = process.env.REACT_APP_PDAPI_BASE_URL;
  if (envBase) return normalizeBase(envBase);

  const isProd = process.env.NODE_ENV === "production";
  return normalizeBase(isProd ? PROD_PDAPI_BASE : DEV_PDAPI_BASE);
};

export default getPdApiBase;
